<template>
  <div class="copy-text">
    <div class="fake-input text-truncate">
      {{ value }}
    </div>
    <button class="btn btn-primary my-2" type="button" @click="writeOnClipboard">
      <slot></slot>
      <i class="fas fa-copy"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: String
  },
  methods: {
    writeOnClipboard () {
      navigator.clipboard.writeText(this.value).then(() => {
        this.$emit('copied-content')
      }).catch(error => {
        this.$emit('copy-content-fail', error)
      })
    }
  }
}
</script>

<style lang="scss">
.copy-text {
  .fake-input {
    border: 1px solid #4B68EE;
    border-radius: 4px;
    font-size: 16px;
    padding: 9px 16px;
    color: #707070;
    min-height: 44px;
  }

  button {
    .fas.fa-copy {
      float: right;
      line-height: 1.3;
    }
  }
}
</style>
